var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      class: [
        "js-header fixed top-0 left-0 w-full z-max transform translate-y-0 transition-transform duration-200 ease-in-out",
        {
          "-translate-y-header-top-mobile lg:-translate-y-header-top-desktop":
            _vm.isShrinked,
          "shadow-header": _vm.isScrolling
        },
        { "translate-y-0": !_vm.isShrinked },
        {
          "z-chatbot-back": !_vm.isMobileOpen,
          "z-chatbot-front": _vm.isMobileOpen
        }
      ]
    },
    [
      !_vm.slim
        ? _c("ShortcutNav", {
            attrs: {
              navItems: _vm.shortcutsNav,
              savedUrl: _vm.savedUrl,
              searchUrl: _vm.searchUrl
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "relative z-50 transition-colors duration-200 ease-in-out",
            { "bg-transparent": _vm.isMobileOpen },
            { "bg-white": !_vm.isMobileOpen }
          ]
        },
        [
          _c("div", { staticClass: "o-wrapper" }, [
            _c(
              "div",
              {
                class: [
                  "h-header-main-mobile lg:h-header-main-desktop flex flex-nowrap items-center"
                ]
              },
              [
                _c("Logo"),
                _vm._v(" "),
                _c(
                  "nav",
                  {
                    staticClass:
                      "flex mobile+tablet:hidden items-center mx-auto"
                  },
                  [
                    _c(
                      "ul",
                      {
                        staticClass:
                          "flex flex-grow-0 items-start justify-evenly list-none lg:flex-nowrap xl:items-center"
                      },
                      _vm._l(_vm.computedNav, function(navItem, index) {
                        return _c(
                          "li",
                          {
                            key: navItem.id,
                            class: [
                              "group-megamenu py-6.5",
                              index === 0 ? "" : "ml-5"
                            ]
                          },
                          [
                            _c(
                              "a",
                              {
                                class: [
                                  "u-body-sm text-center xl:text-left xl:u-body-md group relative inline-block text-primary-navy font-bold focus:outline-none before:hidden hover:before:block before:w-full before:h-6.5 before:absolute before:top-full before:left-0 before:cursor-default",
                                  navItem.classes,
                                  {
                                    "cursor-default": !navItem.url
                                  }
                                ],
                                attrs: {
                                  href: navItem.url,
                                  target: navItem.newWindow ? "_blank" : "_self"
                                },
                                on: {
                                  focus: function($event) {
                                    return _vm.openDesktopMegamenu(navItem.id)
                                  },
                                  blur: function($event) {
                                    return _vm.closeDesktopMegamenu(false)
                                  },
                                  mouseover: function($event) {
                                    return _vm.openDesktopMegamenu(navItem.id)
                                  },
                                  mouseleave: function($event) {
                                    return _vm.closeDesktopMegamenu(false)
                                  }
                                }
                              },
                              [
                                _c("span", {
                                  class: [
                                    "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                  ]
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    class: [
                                      "hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(navItem.title) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            navItem.children &&
                            _vm.activeDesktopMegamenu === navItem.id
                              ? _c(
                                  "transition",
                                  {
                                    key: "megamenu-" + navItem.id,
                                    attrs: {
                                      appear: "",
                                      "enter-class": "menu-enter",
                                      "enter-active-class": "menu-enter-active",
                                      "enter-to-class": "menu-enter-to",
                                      "leave-class": "menu-leave",
                                      "leave-active-class": "menu-leave-active",
                                      "leave-to-class": "menu-leave-to"
                                    }
                                  },
                                  [
                                    navItem.attributes !== null &&
                                    navItem.attributes.megamenuType ===
                                      "communities"
                                      ? _c("MegamenuAlternative", {
                                          attrs: {
                                            type: "communities",
                                            navItem: navItem,
                                            communities: _vm.communities,
                                            closeDesktopMegamenu:
                                              _vm.closeDesktopMegamenu,
                                            openDesktopMegamenu:
                                              _vm.openDesktopMegamenu,
                                            nearbyRedirectUrl:
                                              _vm.findCommunitiesUrl,
                                            enquireUrl: _vm.enquireUrl
                                          }
                                        })
                                      : navItem.attributes !== null &&
                                        navItem.attributes.megamenuType ===
                                          "homesForSale"
                                      ? _c("MegamenuAlternative", {
                                          attrs: {
                                            type: "homesForSale",
                                            navItem: navItem,
                                            communities: _vm.communities,
                                            closeDesktopMegamenu:
                                              _vm.closeDesktopMegamenu,
                                            openDesktopMegamenu:
                                              _vm.openDesktopMegamenu,
                                            nearbyRedirectUrl: _vm.findHomesUrl,
                                            enquireUrl: _vm.enquireUrl
                                          }
                                        })
                                      : _c("MegamenuDefault", {
                                          attrs: {
                                            navItem: navItem,
                                            closeDesktopMegamenu:
                                              _vm.closeDesktopMegamenu,
                                            openDesktopMegamenu:
                                              _vm.openDesktopMegamenu
                                          }
                                        })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mr-3 mobile+tablet:ml-auto" },
                  [
                    _c("CtaButton", {
                      attrs: {
                        buttonType: "secondary",
                        label: "1300&nbsp;50&nbsp;55&nbsp;60",
                        url: "tel:1300358210",
                        clickFunction: _vm.callClickHandle,
                        labelClassList: "hidden xs:inline",
                        iconId: "icon-phone",
                        iconClassList:
                          "w-4 h-4 md:w-6 md:h-6 lg:w-4 lg:h-4 xl:w-6 xl:h-6 xs:mr-2"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mobile+tablet:hidden" },
                  [
                    _c("CtaButton", {
                      attrs: {
                        buttonType: "primary",
                        label: _vm.enquireBookCtaLabel,
                        url: _vm.enquireBookCtaUrl
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: [
                      "hamburger hamburger--elastic border border-solid rounded-lg transition-colors duration-200 ease-in-out lg:hidden",
                      { "is-active border-primary-navy": _vm.isMobileOpen },
                      { "border-primary": !_vm.isMobileOpen }
                    ],
                    attrs: {
                      type: "button",
                      "aria-label":
                        "!isMobileOpen ? 'Open menu' : 'Close menu'",
                      "aria-expanded": _vm.isMobileOpen ? true : false
                    },
                    on: {
                      click: function($event) {
                        !_vm.isMobileOpen
                          ? _vm.openMobileMenu()
                          : _vm.closeMobileMenu()
                      }
                    }
                  },
                  [_vm._m(0)]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("MobileNavMenu", {
        ref: "mobileNavMenu",
        attrs: {
          isMobileOpen: _vm.isMobileOpen,
          nav: _vm.mobileNav,
          communities: _vm.communities,
          enquireCtaLabel: _vm.enquireBookCtaLabel,
          enquireCtaUrl: _vm.enquireBookCtaUrl,
          savedUrl: _vm.savedUrl,
          searchUrl: _vm.searchUrl,
          findCommunitiesUrl: _vm.findCommunitiesUrl,
          findHomesUrl: _vm.findHomesUrl
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "hamburger-box" }, [
      _c("span", { staticClass: "hamburger-inner" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }